export const mapApiToCard = (apiUser, pageUser) => {
  const profile = apiUser.profile;
  const portfolio = apiUser.portfolio;
  if (!profile) {
    console.error(`Profile missing for ${apiUser.username || pageUser.id || pageUser.uuid}`);
  }
  if (!portfolio) {
    console.error(`Portfolio missing for ${apiUser.username || pageUser.id || pageUser.uuid}`);
  }
  if (!profile?.picture) {
    console.error(
      `Profile picture not found for ${apiUser.username || pageUser.id || pageUser.uuid}`
    );
  }

  return {
    uuid: apiUser?.uuid,
    username: apiUser?.username,
    firstName: apiUser?.firstName,
    name: apiUser?.name,
    accessKey: apiUser?.accessKey,
    headline: apiUser?.profile?.headline || null,
    description: apiUser?.profile?.description || null,
    picture: apiUser?.profile?.picture || null,
    primarySkillTitle: apiUser?.portfolio?.primarySkill?.noun || null,
    skills: portfolio?.orderedSkills?.map((skill) => skill.label) || [],
    workedAtName: portfolio?.workedAtName,
    portfolioItems: apiUser?.portfolioItems
      ?.filter((item) => !!item.image)
      .map(({ id, image, url, uuid }) => {
        return {
          id,
          image,
          uuid,
          link: `${process.env.NEXT_PUBLIC_SITE_URL}/resumes/${apiUser.username}/items/${id}`,
        };
      }),
  };
};

export const mapJsonToCard = (jsonUser) => {
  return {
    userId: jsonUser?.userId,
    orderNo: jsonUser?.orderNo || null,
    username: jsonUser?.username,
    firstName: jsonUser?.firstName,
    name: jsonUser?.name,
    headline: jsonUser?.shortDescription,
    description: jsonUser?.description,
    picture: jsonUser?.image,
    primarySkillTitle: jsonUser?.primarySkillTitle || null,
    skills: jsonUser?.skillSet?.map((skill) => skill.skillDisplayInfo.label) || [],
    portfolioItems: jsonUser?.portfolioFields?.jobPortfolios || [],
  };
};
